var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shehuixinzhike"},[_c('PublicCert',{attrs:{"logo":_vm.Logo8,"type":'jy-sm',"color":'#472784'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }